// extracted by mini-css-extract-plugin
export default {"container":"qq-z","heading":"rq-z","text":"sq-z","info":"tq-z","link":"uq-z","fullMaxWidth":"vq-z"};